import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/routes';
import { useAuthBootstrap } from '@/features/auth/useAuth';
import { store } from '@/store';

/**
 * The session check runs inside the Provider and above the router, so every route — the
 * login screen included — reads one answer to "who is this?" rather than each asking
 * for itself.
 */
function Bootstrap() {
  useAuthBootstrap();
  return <AppRoutes />;
}

export function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Bootstrap />
      </BrowserRouter>
    </Provider>
  );
}
